import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import './product-card-alignment';

document.querySelectorAll('[data-product-slider]').forEach((slider) => {
  const updateNavigation = (swiper) => {
    slider.classList.toggle('_disabled', swiper.isLocked);
  };

  new Swiper(slider.querySelector('.swiper'), {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 0,
    grabCursor: true,
    watchOverflow: true,
    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev'),
    },
    on: {
      init: updateNavigation,
      resize: updateNavigation,
      lock: updateNavigation,
      unlock: updateNavigation,
    },
  });
});
